/*
 * Copyright (C) 2019 - present by OpenGamma Inc. and the OpenGamma group of companies
 *
 * Please see distribution for license.
 */

import { createSelector, createFeatureSelector } from '@ngrx/store';
import { SharedDataState } from './shared-data.state';

// -------------------------------------------------------------------------
const sharedDataState = createFeatureSelector<SharedDataState>('shared-data');

// -------------------------------------------------------------------------
export const getPreviewEnvironments = createSelector(
  sharedDataState,
  state => state.previewEnvironments
);

export const getPreviewEnvironmentsData = createSelector(
  getPreviewEnvironments,
  state => state.data
);
export const arePreviewEnvironmentsLoading = createSelector(
  getPreviewEnvironments,
  state => state.loading
);
export const getPreviewEnvironmentsError = createSelector(
  getPreviewEnvironments,
  state => state.error
);

// -------------------------------------------------------------------------
export const getTenants = createSelector(sharedDataState, state => state.tenants);

export const getTenantsData = createSelector(getTenants, state => state.data);
export const isTenantsLoading = createSelector(getTenants, state => state.loading);
export const getTenantsError = createSelector(getTenants, state => state.error);
